/**
 * @module navigation
 */
(function Navigation() {

    /**
     * Handle tapping for touch based devices of responsive navigation
     *
     * using Library - libs/DoubleTapToGo.js
     */
    function touchDeviceDoubleTapToGoNavigation() {
        /**
         * // local object availability
         * @type {touchDeviceDoubleTapToGoNavigation}
         *  using .call() on the function call.
         *  Other wise the "this" is pointing to window.Juzo
         * @private
         */
        var _this = this;


        /**
         * @type {number}
         */
        this.juzoNavigationBarBreakpoint = 1024;

        /**
         * @type {jQuery|HTMLElement(s)}
         * @return {undefined}
         */
        this.$navFirstLevelLinkElements = $('.nav-level-1.sub');

        /**
         * @method triggerDoubleTapToGo
         * @returns {undefined}
         */
        this.triggerDoubleTapToGo = function () {
            var $windowWidth = $(window).width();
            if ($windowWidth >= _this.juzoNavigationBarBreakpoint) {
                _this.$navFirstLevelLinkElements.doubleTapToGo();
            }
        };

        /**
         * @method windowResize
         * @returns {undefined}
         */
        this.windowResize = function () {
            window.addEventListener('resize', _this.triggerDoubleTapToGo);
        };


        /**
         * navigation constructor
         * @constructor
         * @method init
         * @return {undefined}
         */
        this.init = function () {
            _this.triggerDoubleTapToGo();
            _this.windowResize();

        };

        /**
         * initialize call
         */
        _this.init();


    }


    /**
     * Handle visibility of responsive navigation
     * @param buttonMenu {String} Button identifier
     * @method navigation
     */
    function navigation(buttonMenu) {
        /**
         * // local object availability
         * @type {navigation}
         * @private
         */
        var _this = this;
        /**
         * CTA identifier
         * @type {string}
         */
        var subMenuCTA = '[data-js=nav-sub]';

        /**
         * CTA identifier
         * @type {string}
         */
        var subMenuCTABack = '[data-js=nav-sub-back]';

        /**
         * CTA identifier
         * @type {string}
         */
        var buttonLanguage = '[data-js=navigation-mobile-language]';

        /**
         * CTA identifier
         * @type {string}
         */
        var languageNavSub = '[data-js=main-nav--sub-language]';

        /**
         * state handler for ux (true -> open)
         * @type {{language: number, navigation: number}}
         */
        var state = {
            language: false,
            navigation: false
        };

        /**
         * navigation constructor
         * @constructor
         * @method init
         * @return {undefined}
         */
        this.init = function () {
            _this.observer();
        };

        /**
         * observe toggle button
         * @method observer
         * @return {undefined}
         */
        this.observer = function () {
            $(buttonMenu).click(function () {
                state.navigation = !state.navigation;
                if (state.language) {
                    _this.languageAction();
                } else {
                    _this.toggleSidebar();
                }
            });

            $(subMenuCTA).click(function () {
                var submenu = $(this).parent().find('> .main-nav--sub');
                var submenuContent = $(submenu).find("> div")
                submenu.addClass('visible');
                $("ul.main-nav--list").css("height", submenuContent.outerHeight() + "px");

                // Set height of the menu to prevent hidden menu items
                var submenuContainer = submenu.find('> ul');
                $('.main-nav > ul').height(submenuContainer.height())
            });

            $(subMenuCTABack).click(function () {
                $(this).closest('.main-nav--sub').removeClass('visible');

                // Set height of the menu to prevent hidden menu items
                var newActive = $(this).closest('.main-nav--sub.visible').first().find(" > div > ul");
                if (newActive.height() !== undefined) {
                    $('.main-nav > ul').css("height", newActive.height() + "px");
                } else {
                    $('.main-nav > ul').height('unset');
                }
            });

            $(buttonLanguage).click(function () {
                _this.languageAction(true);
            });
        };

        this.checkState = function () {
            $.each(state, function (key, value) {
                if (value) {
                    return true;
                }
            });
            return false;
        };


        this.languageAction = function (fromButtonMenu) {
            // toggle states
            state.language = !state.language;
            // toggle language and toggle sidebar only when
            _this.toggleLanguages();
            if (!state.navigation) {
                _this.toggleSidebar();
            } else if (fromButtonMenu) {
                // set to false to close sidebar when user hits the language button twice
                state.navigation = false;
            }
        };


        this.toggleSidebar = function () {
            $('body').toggleClass('show-responsive-nav');

            // Set height of the menu to prevent hidden menu items
            var openMenuHeight = $('.main-nav').find('.visible').last().find('> ul').height();
            $('.main-nav > ul').height(openMenuHeight);

        };

        this.toggleLanguages = function () {
            $(languageNavSub).toggleClass('visible');
        };

        /**
         * initialize call navigation
         */
        _this.init();

    }

    /**
     * in page navigation
     * Native browser smooth scrolling
     */
    function productPageNavigation() {

        /**
         * @type {productPageNavigation}
         * @private
         */
        var _this = this;

        /**
         * @type {jQuery|HTMLElement}
         * @return {undefined}
         */
        this.link = $('.js-scroll-link');

        /**
         * @type {jQuery|HTMLElement}
         */
        this.detailNav = $('.js-product-detail-nav');

        /**
         * @type {jQuery|HTMLElement}
         */
        this.detailNavPlaceholder = $('.js-product-detail-nav_placeholder');

        /**
         * @type {jQuery|HTMLElement}
         */
        this.$headerElement = $("[data-html-element='header']");

        /**
         * @type {number}
         */
        this.navPos = 0;

        /**
         * @type {number}
         */
        this.navHeight = 0;

        /**
         * @type {number}
         */
        this.headerHeight = 0;

        /**
         * scroll speed in milliseconds
         * @type {number}
         */
        this.scrollSpeed = 500;

        /**
         * @type {boolean}
         */
        this.isStickyHeader = false;

        /**
         * @type {number}
         */
        this.offSetHeight = 0;

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.checkIfHeaderIsSticky();
            _this.setHeaderHeight();
            _this.setNavHeight();
            _this.setNavPos();
            _this.positionOfNavigationHandler();
            _this.navigationHandler();
        };

        /**
         * @method checkIfHeaderIsSticky
         * @returns {undefined}
         */
        this.checkIfHeaderIsSticky = function () {
            _this.isStickyHeader = _this.$headerElement.data().hasOwnProperty('stickyNavigation');
        };

        /**
         * @method setHeaderHeight
         * @returns {undefined}
         */
        this.setHeaderHeight = function () {
            _this.headerHeight = _this.$headerElement[0].offsetHeight;
        };

        /**
         * @method setNavHeight
         * @returns {undefined}
         */
        this.setNavHeight = function () {
            // .outerHeight() including padding and margin of the element
            _this.navHeight = this.detailNav.outerHeight();
        };

        /**
         * @method setNavPos
         * @returns {undefined}
         */
        this.setNavPos = function () {
            var pos = this.detailNav.position().top;
            _this.navPos = pos - _this.navHeight;
        };

        /**
         * @method fixNav
         * @returns {undefined}
         */
        this.positionOfNavigationHandler = function () {
            $(window).scroll(function () {
                if ($(window).scrollTop() > _this.navPos) {
                    _this.stickNavigation();
                }
                if ($(window).scrollTop() < _this.navPos) {
                    _this.unstickNavigation();
                }
            });
        };


        /**
         * @method setHeaderHeight
         * @returns {integer}
         */
        this.setOffSetHeight = function () {
            if (_this.isStickyHeader) {
                _this.offSetHeight = _this.headerHeight;
            } else {
                _this.offSetHeight = 0;
            }
        };

        /**
         * @method stickNavigation
         * @returns {undefined}
         */
        this.stickNavigation = function () {
            _this.setOffSetHeight();
            _this.detailNav.addClass('fixed');
            _this.detailNav.css('top', _this.offSetHeight);


            // fix position fixed result
            _this.detailNavPlaceholder.css('line-height', _this.navHeight + 'px');
        };

        /**
         * @method unstickNavigation
         * @returns {undefined}
         */
        this.unstickNavigation = function () {
            _this.detailNav.removeClass('fixed');
            _this.detailNavPlaceholder.removeAttr('style');
        };

        /**
         * @method navigationHandler
         * @returns {undefined}
         */
        this.navigationHandler = function () {
            $.each(_this.link, function (index, element) {
                var target = $($(element).attr('href'));

                // Make sure the target (CSS ID) exists
                if (target.length) {
                    _this.activeSectionLinkHandler(index, target);
                    _this.scrollToTargetSectionHandler(index, target);
                }
            });
        };

        /**
         * @param index {integer}
         * @param target {jQuery|HTMLElement}
         * @method scrollLinkObserver
         * @returns {undefined}
         */
        this.scrollToTargetSectionHandler = function (index, target) {
            _this.link.eq(index).click(function (e) {
                var offsetClick = target.offset().top - (_this.navHeight + _this.offSetHeight);
                e.preventDefault();
                $('html, body').animate({
                    'scrollTop': offsetClick
                }, _this.scrollSpeed)
            });

        };

        /**
         * @param index {integer}
         * @param target {jQuery|HTMLElement}
         * @method scrollLinkObserver
         * @returns {undefined}
         */
        this.activeSectionLinkHandler = function (index, target) {
            $(document).scroll(function () {
                var offsetSection = target.offset().top;
                var docScroll = $(document).scrollTop();
                var docScroll1 = docScroll + _this.navHeight;

                if (docScroll1 >= offsetSection - 1) {
                    _this.link.removeClass('active');
                    _this.link.eq(index).addClass('active');
                }

            });
        };

        // initialize
        _this.init();
    }

    // define the global scope
    if (!window.Juzo) {
        window.Juzo = {};
    }

    window.Juzo.navigation = navigation;
    window.Juzo.productPageNavigation = productPageNavigation;
    window.Juzo.touchDeviceDoubleTapToGoNavigation = touchDeviceDoubleTapToGoNavigation;
})();

$(document).ready(function () {
    window.Juzo.navigation('[data-js=navigation]');
    window.Juzo.touchDeviceDoubleTapToGoNavigation.call(window.Juzo.touchDeviceDoubleTapToGoNavigation);
    if ($('.js-product-detail-nav').length) {
        window.Juzo.productPageNavigation();
    }
});
